export const parseError = (error) => {
  if (Object.keys(error.errors).length) {
    let firstError = Object.entries(error.errors)[0];
    let key = firstError[0].charAt(0).toUpperCase() + firstError[0].slice(1);
    let message = firstError[1];
    return key + ' ' + message;
  }
  return 'Unknown error occurred';
};
